import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Aplicativos from "./pages/Aplicativos";
import NotFound from "./pages/NotFound";
import AplicativoDetalle from "./pages/AplicativoDetalle";
import About from "./pages/About";
import Contact from "./pages/Contact";

function App() {
  return (
    <Router>
      <Routes>
        {/* Rutas públicas */}
        <Route element={<Layout />}>
          <Route index path="/" element={<Home />} />
          <Route path="/home" element={<Navigate to="/" />} />
          <Route path="/Aplicativos" element={<Aplicativos/>} />
          <Route path="/Aplicativos/:nombre" element={<AplicativoDetalle />} />
          <Route path="/About" element={<About/>} />
          <Route path="/contact" element={<Contact />} />
        </Route>

        {/* Ruta 404 */}
        <Route path="/NotFound" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/NotFound" />} />
      </Routes>
    </Router>
  );
}

export default App;
